import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import App from './App.vue'
import './registerServiceWorker'
import './plugins/acl'
import PermissionGuard from '@/components/permission/PermissionGuard.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

Vue.component('PermissionGuard', PermissionGuard)

Vue.config.productionTip = false

const toastOptions = {
  position: 'top-center',
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  closeButton: 'button',
  icon: true,
  rtl: false,

  // エラーだけ長く出す。2秒では読み切れないため。
  // 「削除できません」のように理由が別トーストで続く箇所があり、
  // 複数行の日本語が2枚重なって2秒で消えると理由が伝わらない。
  //
  // 自動で消さない案もあるが、営業中のタブレットで消すタップが増えるので
  // 秒数を伸ばすほうを選んだ。閉じるボタンは常時出ている。
  toastDefaults: {
    error: { timeout: 8000 },
    warning: { timeout: 5000 },
  },
}
Vue.use(Toast, toastOptions)

Vue.mixin({
  computed: {
    currentUser() {
      return JSON.parse(localStorage.getItem('currentUser') || '{}')
    },
    currentClub() {
      return JSON.parse(localStorage.getItem('currentClub') || '{}')
    },
    userAbilities() {
      return JSON.parse(localStorage.getItem('userAbilities') || '{}')
    },
    currentEnv() {
      return process.env.NODE_ENV
    },
  },
})

if (process.env.NODE_ENV === 'production') {
  const isInternalVerificationUser = () => {
    try {
      const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}')

      return typeof currentUser.email === 'string' && currentUser.email.includes('yona_management')
    } catch (_) {
      return false
    }
  }

  Sentry.init({
    Vue,
    dsn: 'https://115c17a7724d452bae8f0fb7b9a26d5a@o1329206.ingest.sentry.io/6591106',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['yona.yonarezi.com', 'yonarezi.com/api/v1', 'yonarezi.com/api/v2'],
      }),
    ],
    tracesSampler: () => (isInternalVerificationUser() ? 0 : 0.2),
    beforeSend(event) {
      if (isInternalVerificationUser()) return null

      return event
    },
  })
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
